module.exports = __webpack_public_path__ + "img/broadband-providers.5b8d61d.png";